module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-05-d05a2c48673bf08be3d4e544eb3c40d7.webp";